"use client";
import { useEffect, useState } from "react";
import _ from "lodash";
import { usePathname } from "next/navigation";
import { allTab } from "@/constants/common";
export function useTabsActive(curMode, flag?: Boolean) {
  const [activeIndex, setActiveIndex] = useState(allTab[curMode][0].key);
  const pathName = usePathname();
  // const params = searchParams?.get('id');
  useEffect(() => {
    flag ? setActiveIndex(allTab[curMode][0].key) : setActiveIndex(pathName);
  }, [pathName]);

  function changeActive(activePath: string) {
    console.log(activePath);

    setActiveIndex(activePath);
    if (!flag) {
      location.href = activePath;
    }
  }

  return [activeIndex, changeActive];
}
export function getInnerWidth(): string {
  const [pcWidth, setPcWidth] = useState("pc");
  function changeTabsPosition() {
    const htmlWidth = window.innerWidth;
    if (htmlWidth <= 800) {
      setPcWidth("mini");
    } else {
      setPcWidth("pc");
    }
  }
  useEffect(() => {
    window.addEventListener("resize", changeTabsPosition);
    changeTabsPosition();
    return () => {
      window.removeEventListener("resize", changeTabsPosition);
    };
  }, []);
  return pcWidth;
}

export function useResponsiveComponent({ Pc, Mini }) {
  return function ResponsiveWrapper() {
    if (typeof window !== "undefined") {
      const [isPC, setIsPC] = useState<boolean>(window.innerWidth > 800);
      useEffect(() => {
        const checkViewport = () => {
          setIsPC(window.innerWidth > 800);
        };

        // 初始化检查
        checkViewport();

        // 添加 resize 监听
        window.addEventListener("resize", checkViewport);

        // 清理函数
        return () => window.removeEventListener("resize", checkViewport);
      }, []);
      if (isPC) {
        return Pc();
      } else {
        return Mini();
      }
    }
  };
}
